import React from 'react';
import { Card, CardProps } from '@mui/material';

interface GradientCardProps extends CardProps {
  gradient?: string;
  hoverable?: boolean;
}

export const GradientCard: React.FC<GradientCardProps> = ({
  children,
  gradient,
  hoverable = true,
  sx,
  ...props
}) => {
  return (
    <Card
      {...props}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background: gradient || 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: '#ffffff',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        ...(hoverable && {
          '&:hover': {
            transform: 'translateY(-8px) scale(1.02)',
            boxShadow: '0px 20px 60px rgba(99, 102, 241, 0.3)',
          },
        }),
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
          opacity: 0,
          transition: 'opacity 0.3s ease',
        },
        '&:hover::before': {
          opacity: 1,
        },
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};
